export default __webpack_public_path__ + "static/media/tech-flask.144ba1e1.svg";